import React from "react"
import Warning from "../Warning"
import styles from './SystemCheck.module.scss'
import Icon, { IconType } from "@bt-react/components/Icon"
import Modal from "@bt-react/components/Modal"
import Button from "@bt-react/components/Button"
import Spinner from "../Spinner/Spinner"
import { useState, useEffect } from "react"


const SystemCheck = ({className, inProgress, report, failed}) => {

    const [modalOpen, setModalOpen] = useState(false)
    const [normalisedReport, setNormalisedReport] = useState<any>(null)

    useEffect(() => {

        const scores = {
            0: 'Poor',
            1: 'Suboptimal',
            2: 'Good',
            3: 'Excellent'
        }

        if (report) {
            setNormalisedReport({
                rtt: `${report.latency.average} / ${report.latency.max} (${scores[report.latency.qualityScore]})`,
                jitter: `${report.jitter.average} / ${report.jitter.max} (${scores[report.jitter.qualityScore]})`,
                packetLoss: `${report.packetLoss.average}% / ${report.packetLoss.max}% (${scores[report.packetLoss.qualityScore]})`,
                bitrate: `${report.bitrate.average} / ${report.bitrate.max} (${scores[report.bitrate.qualityScore]})`
            })
        }
    }, [report])

    const onModalCloseClick = () => {
        setModalOpen(false)
    }

    const onDetailsClick = (e) => {
        e.preventDefault()
        setModalOpen(true)
    }

    const getContent = () => {
        if (failed) {
            return <Warning color='red'>
                <b><Icon className={`${styles['warning-icon']} ${styles['warning-icon-red']}`} name={IconType.iconName.dangerCentral} />Connection failed!&nbsp;</b>
                It's possible that you're behind a firewall that will need to be updated by your network administrator. Contact your network administrator and <a target="_blank" href='https://techtarget.service-now.com/csm/en/network-for-presenting?id=kb_article_view&sysparm_article=KB0030376' rel="noreferrer">visit Support</a> for details.
            </Warning>
            
        }

        if (report && report.totalQualityScore === 0) {
            return <Warning color='yellow'>
                <b><Icon className={`${styles['warning-icon']} ${styles['warning-icon-yellow']}`} name={IconType.iconName.dangerCircle} />Poor quality!&nbsp;</b>
                Your expected audio and video quality is degraded and overall performance may be poor (<a href='/' onClick={(e) => onDetailsClick(e)}>view detailed quality information</a>). Contact your network administrator and <a target="_blank" href='https://techtarget.service-now.com/csm/en/network-for-presenting?id=kb_article_view&sysparm_article=KB0030376' rel="noreferrer">visit Support</a> for details.
            </Warning>
        }
    
        if (report && report.totalQualityScore === 1) {
            return <Warning color='yellow'>
                <b><Icon className={`${styles['warning-icon']} ${styles['warning-icon-yellow']}`} name={IconType.iconName.dangerCircle} />Suboptimal quality!&nbsp;</b>
                Your expected audio and video quality is degraded and overall performance may be suboptimal (<a href='/' onClick={(e) => onDetailsClick(e)}>view detailed quality information</a>). Contact your network administrator and <a target="_blank" href='https://techtarget.service-now.com/csm/en/network-for-presenting?id=kb_article_view&sysparm_article=KB0030376' rel="noreferrer">visit Support</a> for details.
            </Warning>
        }
    
        if (report && report.totalQualityScore > 1) {
            
            return <div className={styles['general-status']}>
                <Icon name={IconType.iconName.tick} className={styles['progress-icon']} colour={IconType.colour.brightTALK} />
                {`Expected quality is ${report.totalQualityScore === 2 ? 'good!' : 'excellent!'}`}
            </div>
        }
    
   
        return <div className={styles['general-status']}>
            <Icon name={IconType.iconName.spinner} className={styles['progress-icon']} colour={IconType.colour.brightTALK} />
            System check in progress
        </div>
    }
    
    return <div className={`${styles['system-check']} ${className}`}>
        {getContent()}
        {normalisedReport && <Modal isOpen={modalOpen} concise={true} dataBdd='network-quality-modal'>
        <Modal.Body>
          <div className={styles['report-header']}>Detailed connection information</div>
          <div className={styles['report']}>
            <div>Network info</div><div>Score</div>
            <div>RTT (ms) avg/max</div><div>{normalisedReport.rtt}</div>
            <div>Jitter (s) avg/max</div><div>{normalisedReport.jitter}</div>
            <div>Packet loss avg/max</div><div>{normalisedReport.packetLoss}</div>
            <div>Bitrate (kbps) avg/max</div><div>{normalisedReport.bitrate}</div>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles['report-footer']}>
          <Button
            dataBdd="close-button"
            onClick={onModalCloseClick}
            color={IconType.colour.link}
            text={'Close'}
          />
        </Modal.Footer>
      </Modal>}
    </div>
    
}

export default SystemCheck